<template>
  <div style="position: relative;"  v-if="field.Visable">
    <van-field :label="label" :required="field.Nullable == true"  :label-width="config.labelWidth" :disabled="isEditSaved || !field.Editable"
               :style="'height: ' + config.cellHeight + 'px; line-height: ' + config.cellHeight + 'px;'" >
      <template #input>
        <el-color-picker size="small" show-alpha   :style="'font-weight: ' + weightList[pageSetup.wordWeight] + '; font-size: ' + sizeList[pageSetup.wordSize] + 'px; background-color: #fff; height: ' +
             (config.cellHeight - 20) + 'px; line-height: ' + (config.cellHeight - 20) + 'px;'"  ></el-color-picker>
        <!--<van-rate></van-rate>-->
      </template>
    </van-field>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
import { Field } from 'vant'
export default {
  name: 'nxMobileColor',
  components: {
    [Field.name]: Field
  },
  props: {       pageSetup: Object,
    value: String,
    label: String,
    config: Object,
    children: Array,
      mastertable: Object,
      tables: Array,
    cssdiy: Object,
      isEditSaved: Boolean,
      updateField: Boolean
  },
    data () {
        return {
            weightList: {
                0: 'inherit',
                33: 'normal',
                66: 'bold',
                99: 'bolder'
            },
            sizeList: {
                0: '10',
                33: '14',
                66: '16',
                99: '20'
            },
            field: null
        }
    },
    watch: {
        updateField () {
            let tableList = []
            tableList = this.$utils.deepClone(this.tables)
            tableList.push(this.mastertable)
            this.field = null
            for (let i = 0; i < tableList.length; i++) {
                const table = tableList[i]
                for (let j = 0; j < table.Fields.length; j++) {
                    if ((this.tablecode === undefined || table.TableCode === this.tablecode) && table.Fields[j].FieldCode === this.config.FieldCode) {
                        this.field = table.Fields[j]
                    }
                }
                if (this.field !== null) {
                    break
                }
            }
        }
    },
    mounted () {
        const tableList = this.tables
        tableList.push(this.mastertable)
        for (let i = 0; i < tableList.length; i++) {
            const table = tableList[i]
            if (table.TableCode === this.tablecode) {
                for (let j = 0; j < table.Fields.length; j++) {
                    if (table.Fields[j].FieldCode === this.config.FieldCode) {
                        this.field = table.Fields[j]
                    }
                }
            }
            if (this.field !== null) {
                break
            }
        }
    }
}
</script>

<style scoped>

</style>
